import LandingPageBody from './LandingPageBody'

export default LandingPageBody
